<template lang="pug">
  ods-form.login-form__form(
    :model="loginForm"
    :rules="rules"
    ref="loginForm"
    :hide-required-asterisk="true")
    div
      h1.login-form__title {{ $t('login.title') }}
      .login-form__errors.ods-mb-5
        ods-alert(
          v-show="errors"
          :title="errorInfo || $t('login.loginError')"
          type="error"
          :closable="false")
      ods-form-item(:label="$t('login.user')" prop='user')
        ods-input.user(
          :class="{error: errors}"
          type="text"
          v-model="loginForm.user") fasdfasdf
      ods-form-item.ods-mb-3(:label="$t('login.password')" prop="password")
        ods-input(
          :class="{error: errors}"
          type="password"
          v-model="loginForm.password")
      //- router-link(to="/login/password" tag="div")
      //-   ods-button.ods-p-0(type="text") {{ $t('login.forgotPassword') }}
    div.login-form__actions
      ods-checkbox(v-model="keepMeLogged") {{ $t('login.keepMeLogged') }}
      ods-button(type="primary" native-type="submit" @click.prevent="submitForm('loginForm')") {{ $t('login.login') }}
</template>

<script>
import config from '../../../public/config.json'
import FormStyles from '@/components/login/LoginFormStyles.vue'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'LoginForm',
  mixins: [FormStyles],
  data () {
    return {
      loginForm: {
        user: '',
        password: ''
      },
      rules: {
        user: [
          { required: true, message: this.$t('login.rules.user'), trigger: 'submit' }
        ],
        password: [
          { required: true, message: this.$t('login.rules.password'), trigger: 'submit' }
        ]
      },
      keepMeLogged: true,
      errors: false,
      errorInfo: '',
      useSocialLogin: true,
      semilla: config.semilla
    }
  },

  created () {
    this.$store.dispatch('getConfig')
  },

  methods: {
    ...mapActions([
      'login',
      'loader'
    ]),

    ...mapGetters([
      'getErrorDescription'
    ]),

    submitForm (formName) {
      const _this = this
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.loader({ loader: true })
          const data = {
            username: this.loginForm.user.toUpperCase(),
            password: this.loginForm.password + this.semilla
          }
          const response = await this.login(data)
          // const isError = response instanceof Error
          if (this.$store.getters.getErrorDescription === '') {
            if (response) {
              const role = response.data.runServiceResponse.return.registros.customer_role
              if (role !== '01' && role !== '02' && role !== '03' && role.toString() !== '99') {
                this.errorInfo = 'El usuario no tiene permisos de acceso'
                this.$notify.closeAll()
                this.$notify({
                  title: _this.$t('login.loginErrorTitle'),
                  message: this.errorInfo,
                  type: 'error',
                  position: 'top-right',
                  duration: 5000
                })
                this.loader({ loader: false })
                this.errors = true
                this.handleCloseSession()
              } else {
                this.$notify.closeAll()
                sessionStorage.sessionToken = response.data.token // dan error
                sessionStorage.userId = response.data.userId
                sessionStorage.mainUser = response.data.mainUser
                this.loader({ loader: false })
                this.$router.push({ path: '/' })
              }
            }
          } else {
            this.errorInfo = this.$options.filters.capitalize(this.$store.getters.getErrorDescription)
            this.$notify.closeAll()
            this.$notify({
              title: _this.$t('login.loginErrorTitle'),
              message: this.errorInfo,
              type: 'error',
              position: 'top-right',
              duration: 5000
            })
            this.loader({ loader: false })
            this.errors = true
            this.handleCloseSession()
          }
        } else {
          this.errors = true
          return false
        }
      })
    },
    handleCloseSession () {
      this.$store.dispatch('logout')
    }
  }
}
</script>
<style lang="scss">
  .user{
    input{
      text-transform: uppercase;
    }
  }
</style>
